// extracted by mini-css-extract-plugin
export default {"information":"style_information__KWVb2","table_container":"style_table_container__CsSWF","required":"style_required__ss4qE"};